import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

interface UserState {
  name: string | null;
  email: string | null;
  userId: string | null;
  userKind: string | null;
}

const initialState: UserState = {
  name: null,
  email: null,
  userId: null,
  userKind: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<{
        name: string;
        email: string;
        userId: string;
        userKind: string;
      }>
    ) => {
      state.name = action.payload.name;
      state.email = action.payload.email;
      state.userId = action.payload.userId;
      state.userKind = action.payload.userKind;
    },
    clearUser: (state) => {
      state.name = null;
      state.email = null;
      state.userId = null;
      state.userKind = null;
    },
  },
});

export const {setUser, clearUser} = userSlice.actions;
export default userSlice.reducer;
